/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, June 2023
 * @flow
 */

import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { Box, Typography } from '@material-ui/core';
import FireboardUtils from '../../util/fireboard-util';
import useStyles from './useStyles';

const CustomSms = ({ sms, storeInfo, onHandleSend, selectedItem, smsIndex, currency }) => {
  const classes = useStyles();
  const [selectedAction, setSelectedAction] = React.useState(-1);

  const { description: customDesciption, message: customMessage } = sms || {};
  let message = '' + (customDesciption ? customDesciption : customMessage ? customMessage : '');

  try {
    const { name: storeName, address1: storeAddress, city: storeCity } = storeInfo || {};
    const { checkNumber, unpaidAmount, orders, businessDate, slotName } = selectedItem || {};
    const { orderDate, pickupDate, checkInNote, address1: deliveryAddress, city: deliveryCity } = Array.isArray(orders) ? orders.length > 0 ? orders[0] : {} : {};
    let orderTimeInHrsMins, orderDt, pickupTimeInHrsMins, pickupDt, businessDt;
    if (orderDate) {
      orderTimeInHrsMins = FireboardUtils.getTimeInHrsMins(orderDate);
      orderDt = FireboardUtils.convertedDate(orderDate);
    }
    if (pickupDate) {
      pickupTimeInHrsMins = FireboardUtils.getTimeInHrsMins(pickupDate);
      pickupDt = FireboardUtils.convertedDate(pickupDate);
    }
    if (businessDate) {
      businessDt = FireboardUtils.convertedDate(businessDate);
    }
    const dataObject = {
      StoreName: storeName,
      StoreAddress: storeAddress,
      StoreCity: storeCity,
      CheckNumber: checkNumber,
      BusinessDate: businessDt,
      UnpaidAmount: `${currency}${unpaidAmount}`,
      OrderDate: orderDt,
      PickupDate: pickupDate ? pickupDt : orderDt,
      PickupTime: pickupDate ? pickupTimeInHrsMins : orderTimeInHrsMins,
      DeliverTo: checkInNote,
      DeliveryAddress: deliveryAddress,
      DeliveryCity: deliveryCity,
      CubbySlotName: slotName,
    };

    Object.entries(dataObject).forEach(([key, value]) => {
      message = message.replaceAll(`{{${key}}}`, value || '--');
    });
  } catch (error) {
    console.error(error);
  }

  return (
    <Box mt={1} mb={1} display={'flex'} alignItems={'center'}
      className={cn(classes.smsRow, { [classes.highlightedRow]: selectedAction === smsIndex })}
      onMouseEnter={() => setSelectedAction(smsIndex)}
      onMouseLeave={() => setSelectedAction(-1)}
      onClick={() => onHandleSend(message, sms)}
    >
      <Typography variant='body2' className={classes.rowContent}>{message}</Typography>
    </Box>
  );
};

export default CustomSms;

CustomSms.propTypes = {
  sms: PropTypes.object,
  storeInfo: PropTypes.object,
  onHandleSend: PropTypes.func,
  selectedItem: PropTypes.object,
  currency: PropTypes.string,
  smsIndex: PropTypes.number,
};
